import { createFileRoute } from '@tanstack/react-router';

import { CompanyProjectsPage } from '@/features/profiles/company-pages';

export const Route = createFileRoute('/_app/org/$orgId/projects')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <CompanyProjectsPage orgId={orgId} />;
}
